module.exports = __webpack_public_path__ + "static/icomm_logo-5441756905cf7b50d73f914675d3b360.png";